document.addEventListener("DOMContentLoaded", () => {
  const carousel = document.getElementById("features-carousel");
  if (!carousel) return;

  const items = carousel.querySelectorAll("li");
  if (items.length <= 1) return;

  let currentIndex = 0;
  let autoplayInterval;
  let isPaused = false;
  let isReversing = false;

  const scrollToItem = (index) => {
    const item = items[index];
    if (item) {
      const scrollPosition = item.offsetLeft - carousel.offsetLeft;
      carousel.scrollTo({
        left: scrollPosition,
        behavior: "smooth",
      });
      currentIndex = index;
    }
  };

  const startAutoplay = () => {
    if (autoplayInterval) clearInterval(autoplayInterval);
    autoplayInterval = setInterval(() => {
      if (!isPaused) {
        if (isReversing) {
          // Scroll backwards
          if (currentIndex > 0) {
            scrollToItem(currentIndex - 1);
          } else {
            // Reached the start, switch to forward direction
            isReversing = false;
            scrollToItem(currentIndex + 1);
          }
        } else {
          // Scroll forwards
          if (currentIndex < items.length - 1) {
            scrollToItem(currentIndex + 1);
          } else {
            // Reached the end, switch to reverse direction
            isReversing = true;
            scrollToItem(currentIndex - 1);
          }
        }
      }
    }, 2500); // Change slide every 3 seconds
  };

  // Pause on user interaction
  const pauseAutoplay = () => {
    isPaused = true;
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  };

  const resumeAutoplay = () => {
    isPaused = false;
    startAutoplay();
  };

  // Pause on hover/touch
  carousel.addEventListener("mouseenter", pauseAutoplay);
  carousel.addEventListener("mouseleave", resumeAutoplay);
  carousel.addEventListener("touchstart", pauseAutoplay);
  carousel.addEventListener("touchend", () => {
    setTimeout(resumeAutoplay, 2000); // Resume after 3 seconds of no touch
  });

  // Pause on scroll (user manually scrolling)
  let scrollTimeout;
  carousel.addEventListener("scroll", () => {
    pauseAutoplay();
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      // Update currentIndex based on scroll position
      const scrollLeft = carousel.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Infinity;
      items.forEach((item, index) => {
        const distance = Math.abs(
          item.offsetLeft - carousel.offsetLeft - scrollLeft
        );
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      currentIndex = closestIndex;
      resumeAutoplay();
    }, 1000);
  });

  // Handle window resize
  window.addEventListener("resize", () => {
    resumeAutoplay();
  });

  // Start autoplay
  startAutoplay();
});
